import {
  // classes
  ActiveSelection,
  Canvas as FabricCanvas,
  Ellipse as FabricEllipse,
  FabricImage,
  FabricObject,
  Group as FabricGroup,
  IText as FabricIText,
  Path as FabricPath,
  Pattern as FabricPattern,
  Point as FabricPoint,
  Rect as FabricRect,

  // interfaces
  GroupProps as FabricGroupProps,
  ImageProps as FabricImageProps,
  FabricObjectProps,
  TextProps as FabricTextProps,
  TEvent,
  TPointerEvent,

  // utils
  filters,
  util,
} from "fabric";

export {
  // classes
  ActiveSelection,
  FabricCanvas,
  FabricEllipse,
  FabricGroup,
  FabricImage,
  FabricIText,
  FabricObject,
  FabricPath,
  FabricPattern,
  FabricPoint,
  FabricRect,

  // utils
  filters,
  util,
};

export type {
  FabricGroupProps,
  FabricImageProps,
  FabricObjectProps,
  FabricTextProps,
  TEvent,
  TPointerEvent,
};
